var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Reports") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-RHQMS",
    transform: "translate(-806.000000, -38.000000)",
    fill: "#6C3964",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reports",
    transform: "translate(806.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2874455,0 C13.0589362,0 12.8736507,0.185285459 12.8736507,0.413794734 L12.8736507,10.712791 C12.8736507,10.9413003 13.0589362,11.1265857 13.2874455,11.1265857 L23.5864417,11.1265857 C23.814951,11.1265857 24.0002365,10.9413003 24.0002365,10.712791 C24.0002365,7.87184186 22.8715463,5.14666068 20.8625847,3.13774636 C18.8536704,1.12883203 16.1283,0 13.28754,0 L13.2874455,0 Z M13.7011456,0.837756996 C16.1725642,0.94120568 18.5211213,1.96663632 20.2770297,3.72287576 C22.0330799,5.47892603 23.0586761,7.82757765 23.1621484,10.2986652 L13.7011456,10.2986652 L13.7011456,0.837756996 Z M10.7126964,2.57460719 C7.87174728,2.57460719 5.14656609,3.70329735 3.13765177,5.71225896 C1.12873745,7.72117329 0,10.4460707 0,13.2873036 C0,16.1282527 1.12869016,18.8534339 3.13765177,20.8623482 C5.14656609,22.8712625 7.87193644,24 10.7126964,24 C13.5536455,24 16.2788267,22.8713098 18.287741,20.8623482 C20.2966554,18.8534339 21.4253928,16.1280636 21.4253928,13.2873036 L21.4253928,13.2874883 C21.4253928,13.058979 21.2401074,12.8736936 21.0115981,12.8736936 L11.1263966,12.8736936 L11.1263966,2.98849206 C11.1263966,2.75998279 10.9411111,2.57460719 10.7126018,2.57460719 L10.7126964,2.57460719 Z M10.2989017,3.41236419 L10.2989017,12.2883795 L4.02199023,6.01146803 C5.74124824,4.43053569 7.96524124,3.51020891 10.2989017,3.41250606 L10.2989017,3.41236419 Z M3.4365298,6.59655013 L10.127236,13.2872563 L3.4365298,19.9779625 C1.76215079,18.1572656 0.827211142,15.7709232 0.827211142,13.2872563 C0.827211142,10.8037312 1.76215079,8.41724696 3.4365298,6.59655013 L3.4365298,6.59655013 Z M10.8838892,13.701051 L20.5874939,13.701051 C20.4840453,16.1723751 19.4586146,18.5209321 17.7025643,20.2768405 C15.8486221,22.1307828 13.3346417,23.1721268 10.7129801,23.1721268 C8.22945509,23.1721268 5.84297081,22.2371871 4.02227398,20.5628081 L10.8838892,13.701051 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.aaae054e8d9e60d748404bd01b6daf2a.svg";
export { ForwardRef as ReactComponent };